/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const NewsIcon = ({ width = 24, height = 24, hidden = false, title = 'News' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 6H5a1 1 0 0 0-1 1v20a1 1 0 0 1-2 0V10.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V27a3 3 0 0 0 3 3h28a3 3 0 0 0 3-3V7a1 1 0 0 0-1-1Zm-2 22H6V8h26v19a1 1 0 0 1-1 1Z"
    />
    <path
      d="M20 12h10v2H20zM20 20h10v2H20zM8 24h10v2H8zM20 16h10v2H20zM20 24h10v2H20zM8 12h10v10H8z"
    />
  </svg>`;
};
